export const iconFontAwesomeBuildingsArrowRightToCity = (
	<i className="fa-solid fa-arrow-right-to-city"></i>
);
